import {
  FormLabel,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
} from "@mui/material";

import { Option } from "api/common/types/common.types";
import { useFieldContext } from "components/Forms/AppForm";
import ErrorMessage from "components/Forms/components/helpers/ErrorMessage";

interface RadioButtonProps {
  options: Option[];
  label: string;
  isHorizontal?: boolean;
  disabled?: boolean;
}

const RadioButton = ({
  options = [],
  label,
  isHorizontal = false,
  disabled = false,
}: RadioButtonProps) => {
  const field = useFieldContext<string>();

  return (
    <FormControl>
      <FormLabel id={`${label}-radio-buttons-group-label`} color="primary">
        {label}
      </FormLabel>
      <RadioGroup
        aria-labelledby={`${label}-radio-buttons-group-label`}
        value={field.state.value}
        name={`${label}-radio-buttons-group`}
        onChange={(e) => field.handleChange(e.target.value)}
        row={isHorizontal}
      >
        {options.map((option) => (
          <FormControlLabel
            key={option.value}
            value={option.value}
            control={<Radio />}
            label={option.label}
            disabled={disabled}
          />
        ))}
      </RadioGroup>
      <ErrorMessage />
    </FormControl>
  );
};
export default RadioButton;
